import dispatchRoutes from './routes'

/* @ngInject */
const dispatchRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(dispatchRoutes.index.path, {
      url: dispatchRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'dispatchCtrl',
      redirectTo: dispatchRoutes.home.path,
    })
    .state(dispatchRoutes.home.path, {
      url: dispatchRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(dispatchRoutes.new.path, {
      url: dispatchRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(dispatchRoutes.edit.path, {
      url: dispatchRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(dispatchRoutes.details.path, {
      url: dispatchRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default dispatchRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/dispatch/dispatch.routes.js